import { render, staticRenderFns } from "./IconPaymentGiro.vue?vue&type=template&id=24f6f283&scoped=true"
import script from "./IconPaymentGiro.vue?vue&type=script&lang=js"
export * from "./IconPaymentGiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f6f283",
  null
  
)

export default component.exports